module.exports = __webpack_public_path__ + "static/img/avatar_r_16.87079fb7.png";